<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <mat-card appearance="outlined">
    <mat-tab-group>
      <mat-tab *ngIf="unassignedParams" label="Unassigned Imports">
        <data-table #unassignedItemsTable (remove)="onRemove($event)" [columns]="columns"
                        [dataProviderParams]="unassignedParams" [dataProvider]="importService" [title]="'Unassigned Imports'"></data-table>
      </mat-tab>
      <mat-tab *ngIf="assignedParams" label="Assigned Imports">
        <data-table #assignedItemsTable [columns]="columns" [dataProviderParams]="assignedParams" [dataProvider]="importService"
                        [title]="'Assigned Imports'"></data-table>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</page-content>
